<template>
  <div>
    <div class="product">
      <!-- 参团头 开始 -->
      <div v-if="attendTitleShow">
        <div class="p-complete-title">
          <h2>{{ detail.name }}</h2>
          <div>
            <div class="img">
              <img :src="detailHeadPic[0].url">
            </div>
            <div class="c-t-r">
              <h4>{{ attend[0].productName[0] }}</h4>
              <div>
                <div class="p">拼团价:￥<span>{{ detail.grouponPrice }}</span></div>
                <div class="o">
                  <del>原价:￥{{ detail.originalPrice }}</del>
                  <span>{{ detail.peopleNumber }}人开团</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="p-group">
          <div class="g-t">
            <!--团员头像-->
            <ul>
              <li v-for="item in attend" :key="item.id">
                <img :src="item.userpic">
              </li>
            </ul>
            <p v-if="Number(attend[0].isGroupon)" class="complete">
              <img src="../assets/images/group-success.png">
            </p>
            <p v-if="group_failed_pic_show" class="complete">
              <img src="../assets/images/group-failed.png">
            </p>
            <p v-if="not_complete_p_show" class="not-complete">还差<span>{{ c_lack }}</span>人，快去召集小伙伴参团吧！</p>
            <div class="time" v-if="countDown_show">
              <div class="time-in">
                <span>剩余</span>
                <div class="cutdown">
                  <vue-countdown-timer
                    class="vue-countdown-timer"
                    @start_callback="startCallBack('event started')"
                    @end_callback="endCallBack('event ended')"
                    :start-time="attend[0].realStartTime"
                    :end-time="attend[0].realEndTime"
                    :interval="1000"
                    :start-label="''"
                    :end-label="''"
                    label-position="begin"
                    :end-text="'拼团已过期!'"
                    :day-txt="'天'"
                    :hour-txt="':'"
                    :minutes-txt="':'"
                    :seconds-txt="''">
                  </vue-countdown-timer>
                </div>
                <span>结束</span>
              </div>
            </div>
          </div>
          <ul class="g-detail">
            <li v-for="(item, index) in attend" :key="item.id">
              <div>
                <img :src="item.userpic">
                <span>{{ item.truename }}</span>
              </div>
              <time>{{ item.payTime }} {{ index === 0 ? '开团' : '参团'}}</time>
            </li>
          </ul>
        </div>
      </div>
      <!-- 参团头 结束 -->
      <!-- 团购介绍 开始 -->
      <div v-if="detailTitleShow">
        <!-- 介绍头 -->
        <div :style="swiperStyle">
          <mt-swipe
            :auto="4000"
            :show-indicators="false">
            <mt-swipe-item v-for="item in detailHeadPic" :key="item.id">
              <img class="p-img" :src="item.url" ref="detailPicImg">
            </mt-swipe-item>
          </mt-swipe>
        </div>
        <h1 class="p-title">
          <span>{{ detail.peopleNumber }}人成团</span>
          {{ detail.title }}
        </h1>
        <div class="p-name">
          <h2>{{ detail.name }}</h2>
          <div class="p-price">
            <small>￥</small>
            <big>{{ detail.grouponPrice }}</big>
            <del>
              <small>￥</small>
              <span>{{ detail.originalPrice }}</span>
            </del>
          </div>
          <div class="p-stock">
            <div>
              <span v-show="Number(detail.isShowStore)">库存：500</span>
            </div>
            <span>已有{{  detail.dealGrouponNumber*1 + detail.dealGrouponNumberV*1  }}人参团</span>
          </div>
        </div>
      </div>
      <div class="p-rule">
        <div class="r-t">
          <span>拼吧</span>
          <a href="javascript:void(0)" @click="ruleShow">
            <span>查看活动规则</span>
            <span> > </span>
          </a>
        </div>
        <div class="r-b">
          <div>
            <i class="iconfont icon-tuandui"></i>
            <span>开团当团长</span>
          </div>
          <i class="iconfont icon-you"></i>
          <div>
            <i class="iconfont icon-zhifu"></i>
            <span>支付</span>
          </div>
          <i class="iconfont icon-you"></i>
          <div>
            <i class="iconfont icon-fenxiang"></i>
            <span>分享</span>
          </div>
          <i class="iconfont icon-you"></i>
          <div>
            <i class="iconfont icon-duihao"></i>
            <span>拼团成功<br>未成功退款</span>
          </div>
        </div>
      </div>
      <div class="p-detail">
        <h4>商品详情</h4>
        <div v-html="c_productInfoSummary"></div>
      </div>
      <div class="p-button">
        <!--<router-link class="b-l" :to="leftBtnUrl" v-html="leftBtnHtml"></router-link>-->
        <!--<router-link class="b-r" :to="rightBtnUrl" v-html="rightBtnHtml" @click="shareShow"></router-link>-->
        <a :href="leftBtnUrl" class="b-l" v-html="leftBtnHtml"></a>
        <a :href="rightBtnUrl" class="b-r" v-html="rightBtnHtml" @click="shareShow"></a>
      </div>
      <!-- 团购介绍 结束 -->
    </div>
  </div>
</template>

<script>
  import { MessageBox, Swipe, SwipeItem, Indicator } from 'mint-ui'
  // import share from '../../node_modules/social-share.js/dist/js/social-share.min'
  // import sharecss from '../../node_modules/social-share.js/dist/css/share.min.css'

  export default {
    name: 'index',
    data () {
      return {
        // 参团情况
        attend: [],
        attendTitleShow: true, // 控制 /details?source=getMyGrouponOrderlist&id=28&pid=0 时显示参团头
        attendWork: true, // 团购在有效期中
        group_failed_pic_show: false, // 拼团失败的图片是否显示
        not_complete_p_show: false, // “还差n人拼团成功” 是否显示
        // 团购介绍
        countDown_show: false,
        // 详情
        detail: {
          id: null,
          name: '',
          title: '',
          picUrl: '',
          ruleInfo: '',
          hours: '',
          originalPrice: '',
          grouponPrice: '',
          productInfoSummary: '',
          peopleNumber: '',
          shareTitle: '',
          sharePicUrl: '',
          shareDescription: '',
          userMaxGrouponNumber: '',
          maxGrouponNumber: '',
          dealGrouponNumber: '',
          dealOrderNumber: '',
          orderNumber: '',
          isShowStore: '',
          dealGrouponNumberV: '',
          orderNumberV: '',
          isShowVirtual: '',
          startTime: '',
          endTime: '',
          gpr: [
            {
              id: '',
              grouponId: '',
              classId: '',
              productId: '',
              productNumber: '',
              productInfo: '',
              productName: ''
            }
          ]
        },
        detailHeadPic: [], // 详情的三张图片
        detailTitleShow: true, // 控制 /#/details?grouponId=11 时展示介绍头
        leftBtnUrl: '', // 左侧按钮地址
        leftBtnHtml: '', // 左侧按钮内容
        rightBtnUrl: '', // 右侧按钮地址
        rightBtnHtml: '', // 右侧按钮内容
        swiperStyle: '', // 轮播图高度
        isInWeChat: false // 是否在微信中打开
      }
    },
    computed: {
      c_productInfoSummary: function () {
        let s = decodeURIComponent(this.detail.productInfoSummary)
        s = s.replace(/img\+/g, 'img ')
        return s
      },
      c_lack: function () {
        // 还差几人拼团成功
        let lackNum = this.detail.peopleNumber * 1 - this.attend.length
        // let lackNum = this.detail.peopleNumber * 1
        return lackNum
      }
    },
    mounted () {
      // console.clear()
      /* 判断当前页面
      *  1. 原始页面 // http://localhost:8081/#/details?grouponId=11
      *  2. 发起团之后的页面: 有参团情况、团购介绍 // http://localhost:8081/#/details?source=getGrouponOrderlistById&grouponOrderlistIdMain=28
      * */
      let source = this.$route.query.source
      if (source === 'getGrouponOrderlistById') { // 参团页面
        let id = this.$route.query.grouponOrderlistIdMain // 团长的id
        this.apiGetGrouponOrderlistById(id) // 获取拼团情况
      } else { // 团购首页，只有团购介绍
        // 读取团购id，拉取团购详情
        let grouponId = this.$route.query.grouponId
        this.apigetGrouponDefinitionForUser(grouponId)
        this.apiIsActivity(grouponId) // 判断该团购是否属于活动
        this.detailTitleShow = true // 展示介绍头
        this.attendTitleShow = false // 隐藏参团头
      }
      // 判断推广来源
      // http://m.mison.cn/group-buy/#/details?grouponId=1&come=qqqun
      let come = this.$route.query.come
      switch (come) {
        case 'qqqun':
          this.$cookie.set('trench', 'qqqun', 3)
          break
        case '360':
          this.$cookie.set('trench', '360', 3)
          break
        case 'seo':
          this.$cookie.set('trench', 'seo', 3)
          break
        case 'baidu':
          this.$cookie.set('trench', 'baidu', 3)
          break
        case 'weixinqun':
          this.$cookie.set('trench', 'weixinqun', 3)
          break
        case 'weibo':
          this.$cookie.set('trench', 'weibo', 3)
          break
        case 'weixingzh':
          this.$cookie.set('trench', 'weixingzh', 3)
          break
        case 'qqgzh':
          this.$cookie.set('trench', 'qqgzh', 3)
          break
        case 'guge':
          this.$cookie.set('trench', 'guge', 3)
          break
        case 'weixinry':
          this.$cookie.set('trench', 'weixinry', 3)
          break
        case 'weibory':
          this.$cookie.set('trench', 'weibory', 3)
          break
        case 'baidury':
          this.$cookie.set('trench', 'baidury', 3)
          break
      }

      // 判断是否是微信浏览器
      if (window.navigator.userAgent.toLowerCase().match(/MicroMessenger/i) == 'micromessenger') {
        this.isInWeChat = true
      } else {
        this.isInWeChat = false
      }
    },
    methods: {
      // 通过团购id获取到团购介绍
      apigetGrouponDefinitionForUser (id) {
        Indicator.open({
          spinnerType: 'fading-circle'
        })
        this.$fetch(
          '/e/ShopSys/doaction.php',
          {
            enews: 'getGrouponDefinitionForUser',
            id: id
          }
        ).then((data) => {
          Indicator.close()
          if (data.id) {
            this.detail = data
            // 给 detailHeadPic 赋值
            this.detail.picUrl.split('&&').forEach((item, index) => {
              if (item) {
                this.detailHeadPic.push({
                  id: index,
                  url: item
                })
              }
            })
            // 改变购买按钮的内容
            this.leftBtnHtml = '更多产品'
            this.leftBtnUrl = 'http://www.mison.cn/live/'
            let buyUrl = '/e/ShopSys/doaction.php?enews=AddBuycar&classid=' + this.detail.gpr[0].classId + '&id=' + this.detail.gpr[0].productId + '&grouponOrderlistIdMain=0&grouponId=' + this.detail.id
            if (this.isInWeChat) {
              this.rightBtnUrl = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxde55bde828bfd6e6&redirect_uri=http://mdalian.mison.cn/e/ShopSys/order/index.php&response_type=code&scope=snsapi_base&state=' + escape(buyUrl) + '#wechat_redirect'
            } else {
              this.rightBtnUrl = buyUrl
            }
            this.rightBtnHtml = `￥<span>${this.detail.grouponPrice}</span>&#12288;${this.detail.peopleNumber}人成团，立即开团！`
            let detailTitlePicMinHeight = 10000
            setInterval(() => {
              if (this.$refs['detailPicImg']) {
                let detailTitlePicHeight = this.$refs['detailPicImg'][0].height
                if (detailTitlePicHeight < detailTitlePicMinHeight) {
                  detailTitlePicMinHeight = detailTitlePicHeight
                }
                this.swiperStyle = `height:${detailTitlePicMinHeight}px`
              }
            }, 500)
          } else { // 未定义
            window.location.href = '/'
          }
        })
      },
      // 通过团购的订单id获取到参团情况
      apiGetGrouponOrderlistById (id) {
        Indicator.open({
          spinnerType: 'fading-circle'
        })
        this.$fetch(
          '/e/ShopSys/doaction.php',
          {
            enews: 'getGrouponOrderlistById',
            grouponOrderlistIdMain: id
          }
        ).then((response) => {
          // console.log(response)
          Indicator.close()
          if (response.status === 1) {
            // console.log(response)
            this.attend = response.msg.data.grouponOrderlist // 渲染参团头
            this.attendTitleShow = true // 显示参团头
            this.detailTitleShow = false // 隐藏介绍头
            // 获取到该团购的详情介绍
            this.detail = response.msg.data.grouponDefinition
            this.apiIsActivity(this.detail.id) // 判断该团购是否属于活动
            this.detail.gpr = response.msg.data.gpr
            // 给 detailHeadPic 赋值
            this.detail.picUrl.split('&&').forEach((item, index) => {
              if (item) {
                this.detailHeadPic.push({
                  id: index,
                  url: item
                })
              }
            })
            // 获取到 userid 来判断是否登录
            let userid = this.$cookie.get('ujqtlmluserid')
            // 判断是否满团 complete=1满团 complete=0未满团
            let complete = this.attend[0].isGroupon * 1
            // 判断是否过期 outofDate=true过期 outofDate=fales没过期
            let outofDate = (new Date(this.attend[0].realEndTime) - new Date() < 0)
            this.attendWork = !outofDate
            // 判断下面两个按钮的内容和连接
            if (userid) {
              // 判断是否在团中
              let ingroup = this.attend.some(item => {
                return (item.memberId * 1 === userid * 1)
              })
              if (ingroup) {
                if (this.attendWork) {
                  if (complete) {
                    this.leftBtnHtml = '更多产品'
                    this.leftBtnUrl = 'http://www.mison.cn/live/'
                    this.rightBtnHtml = '查看我的团购'
                    this.rightBtnUrl = '/e/ShopSys/myGroupon/'
                  } else {
                    this.leftBtnHtml = '更多产品'
                    this.leftBtnUrl = 'http://www.mison.cn/live/'
                    this.rightBtnHtml = '分享给小伙伴们来参团'
                    this.rightBtnUrl = 'javascript:void(0)'
                  }
                } else {
                  this.leftBtnHtml = '更多产品'
                  this.leftBtnUrl = 'http://www.mison.cn/live/'
                  this.rightBtnHtml = '重新开团'
                  this.rightBtnUrl = `/group-buy/#/details?grouponId=${this.detail.id}`
                }
              } else {
                if (this.attendWork) {
                  if (complete) {
                    this.leftBtnHtml = '更多产品'
                    this.leftBtnUrl = 'http://www.mison.cn/live/'
                    this.rightBtnHtml = '我要开团'
                    this.rightBtnUrl = `/group-buy/#/details?grouponId=${this.detail.id}`
                  } else {
                    this.leftBtnHtml = '更多产品'
                    this.leftBtnUrl = 'http://www.mison.cn/live/'
                    this.rightBtnHtml = '我要参团'
                    let buyUrl = `/e/ShopSys/doaction.php?enews=AddBuycar&classid=${this.detail.gpr[0].classId}&id=${this.detail.gpr[0].productId}&grouponOrderlistIdMain=${this.attend[0].id}&grouponId=${this.detail.id}`
                    if (this.isInWeChat) {
                      this.rightBtnUrl = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxde55bde828bfd6e6&redirect_uri=http://mdalian.mison.cn/e/ShopSys/order/index.php&response_type=code&scope=snsapi_base&state=' + escape(buyUrl) + '#wechat_redirect'
                    } else {
                      this.rightBtnUrl = buyUrl
                    }
                  }
                } else {
                  this.leftBtnHtml = '更多产品'
                  this.leftBtnUrl = 'http://www.mison.cn/live/'
                  this.rightBtnHtml = '重新开团'
                  this.rightBtnUrl = `/group-buy/#/details?grouponId=${this.detail.id}`
                }
              }
            } else {
              if (this.attendWork) {
                if (complete) {
                  this.leftBtnHtml = '更多产品'
                  this.leftBtnUrl = 'http://www.mison.cn/live/'
                  this.rightBtnHtml = '我要开团'
                  this.rightBtnUrl = `/group-buy/#/details?grouponId=${this.detail.id}`
                } else {
                  this.leftBtnHtml = '更多产品'
                  this.leftBtnUrl = 'http://www.mison.cn/live/'
                  this.rightBtnHtml = '我要参团'
                  let buyUrl = `/e/ShopSys/doaction.php?enews=AddBuycar&classid=${this.detail.gpr[0].classId}&id=${this.detail.gpr[0].productId}&grouponOrderlistIdMain=${this.attend[0].id}&grouponId=${this.detail.id}`
                  if (this.isInWeChat) {
                    this.rightBtnUrl = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxde55bde828bfd6e6&redirect_uri=http://mdalian.mison.cn/e/ShopSys/order/index.php&response_type=code&scope=snsapi_base&state=' + escape(buyUrl) + '#wechat_redirect'
                  } else {
                    this.rightBtnUrl = buyUrl
                  }
                }
              } else {
                this.leftBtnHtml = '更多产品'
                this.leftBtnUrl = 'http://www.mison.cn/live/'
                this.rightBtnHtml = '重新开团'
                this.rightBtnUrl = `/group-buy/#/details?grouponId=${this.detail.id}`
              }
            }
            // 判断拼团失败的图片是否显示
            // 失败情况：a.先判断过期了，在过期的情况下未满团。如果过期了但是满团当然就不显示
            if (outofDate) {
              if (complete === 0) {
                this.group_failed_pic_show = true
              }
            }
            // 判断“还差n人拼团成功”和“倒计时”是否显示
            // 不显示情况：a.过期了，b.没过期，但是拼团成功了
            // 显示的情况：没过期，拼团还没成功
            if (outofDate) {
              this.not_complete_p_show = false
              this.countDown_show = false
            } else {
              if (complete === 1) {
                this.not_complete_p_show = false
                this.countDown_show = false
              } else {
                this.not_complete_p_show = true
                this.countDown_show = true
              }
            }
            this.attend.forEach(item => {
              // 用户头像，没有的话，加上随机头像
              if (item.userpic === '') {
                let num = Math.ceil(Math.random() * 10) + 1
                if (num < 10) {
                  num = '0' + num
                }
                item.userpic = 'http://img.mison.com.cn/images/home/student-' + num + '.png'
              }
              // 对用户名进行处理
              if (item.truename.length === 2) {
                item.truename = item.truename.slice(0, 1) + ' *'
              } else if (item.truename.length === 3) {
                item.truename = item.truename.slice(0, 1) + ' * ' + item.truename.slice(item.truename.length - 1, item.truename.length)
              } else if (item.truename.length > 3) {
                item.truename = item.truename.slice(0, 1) + ' ** ' + item.truename.slice(item.truename.length - 1, item.truename.length)
              }
            })
          }
        })
      },
      // 倒计时开始前的回调
      startCallBack: function (x) {
        // console.log(x)
      },
      // 倒计时结束后的回调
      endCallBack: function (x) {
        // console.log(x)
        console.log('倒计时结束后的回调')
      },
      // 显示规则
      ruleShow () {
        MessageBox('团购玩法', this.detail.ruleInfo)
      },
      // 显示分享弹窗
      shareShow () {
        let shareBtnHref = document.querySelector('.b-r').getAttribute('href')
        if (shareBtnHref === 'javascript:void(0)') {
          // let location = window.location.href
          // window.clipboardData.setData('Text', location)
          // MessageBox('分享', `地址已复制到剪贴板，快分享给小伙伴一起参加吧~`)
          MessageBox('分享', `将本页面分享给小伙伴一起参加吧~`)
        }
      },
      // 监听router变化
      watchRouter () {
        window.location.reload()
        // console.log(111)
      },
      // 进入页面通过团购id判断该团购是否属于某个促销活动，如果是，将活动id存到cookie中，在注册时提交
      apiIsActivity (id) {
        this.$fetch(
          '/e/activity/index.php',
          {
            type: 'tuangou',
            id: id
          }
        ).then((response) => {
          if (response.code === 200) {
            this.$cookie.set('acid', response.acid, 720)
          }
        })
      }
    },
    watch: {
      '$route': 'watchRouter'
    },
    component: {
      'pic-swiper': Swipe,
      'pic-swiper-item': SwipeItem
    }
  }
</script>

<style lang="less" scoped>
  @import "../assets/adjust.min.css";
</style>
